module.exports = __webpack_public_path__ + "img/icon-trash.87eea031.svg";